<template>
  <div>
    <el-group-title
      title="合同附件表"
      class="ccui-group-wrapper"
      index="contract"
    >
      <template slot="groupTitle">
        <el-form
          :model="form"
          :rules="rules"
          ref="form2"
          label-width="160px"
          class="ccui-form"
          style="overflow:visible;"
        >
          <div class="extend-btn">
            <el-upload
              :show-file-list="false"
              :action="uploadUrl"
              class="upload-demo tow"
              :before-upload="beforeAvatarUpload"
              :on-success="onSuccess"
              :on-error="onError"
              :headers="headers"
            >
              <el-button plain type="single-number">上传附件</el-button>
            </el-upload>
          </div>
          <el-table
            :data="tableData"
            border
            class="ccui-form-child-table"
            max-height="99999"
          >
            <el-table-column
              :show-overflow-tooltip="true"
              label="序号"
              type="index"
              min-width="20%"
              height="36px"
            />
            <el-table-column
              :show-overflow-tooltip="true"
              prop="fileName"
              label="文件名称"
              min-width="140%"
            >
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              prop="fileSize"
              label="文件大小"
              min-width="70%"
            >
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              prop="scaleNum"
              label="操作"
              align="center"
              header-align="center"
              min-width="70%"
            >
              <template slot-scope="scope">
                <span
                  style="color:#0089EF;cursor:pointer"
                  @click="deleteAppend(scope.$index)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </template>
    </el-group-title>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "attachment",
  props: {
    dataInfo: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      form: {},
      rules: {},
      tableData: [],
      uploadUrl: this.$addUrlPerFix(process.env.VUE_APP_UPLOAD_URL), //上传图片
      headers: {
        Authorization: Cookies.get("access_token") || ""
      }
    };
  },
  created() {},
  methods: {
    onSuccess(res) {
      console.log(res);
      let fileData = res.data[0];
      this.tableData.push({
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024) + "kb",
        fileInfoId: fileData.uploadId
      });
    },
    onError() {},
    beforeAvatarUpload(file) {
      console.log(file);
    },
    deleteAppend(index) {
      console.log(index);
      this.tableData.splice(index, 1);
    }
  },
  watch: {
    dataInfo() {
      this.tableData = this.dataInfo;
    }
  }
};
</script>
